import { Cookies } from '@hh.ru/magritte-ui';

import { WindowAnalyticsParams } from 'src/types/window';

type ReturnType = {
    utm_source: string | null;
    utm_medium: string | null;
    utm_campaign: string | null;
    utm_content: string | null;
    utm_term: string | null;
} & WindowAnalyticsParams;

const getDefaultAnalyticsParams = (): ReturnType => ({
    ...window.globalServiceVars.careerPlatformFront.analyticsParams,
    utm_source: Cookies.get('utm_source'),
    utm_medium: Cookies.get('utm_medium'),
    utm_campaign: Cookies.get('utm_campaign'),
    utm_content: Cookies.get('utm_content'),
    utm_term: Cookies.get('utm_term'),
});

export default getDefaultAnalyticsParams;
